import React, {useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {strings} from '../../util/strings';
import './styles.scss';
import {AuthConsumer} from '../../providers/AuthProvider';
import LanguageIcon from '@mui/icons-material/Language';
import EmailIcon from '@mui/icons-material/Email';
import {useIsLanguageActive, useAreNotificationsActive} from './hooks';
import {useNavSelection} from '../app-nav-menu/hooks';
import {useHistory} from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import Icon from '../icon';
import colors from '../../util/colors';
import * as fonts from '../../util/fonts';
import {Icons} from '../../util/icons';
import {Row} from '../layout';
import {upperCase} from 'lodash';
import LogoutIcon from '@mui/icons-material/Logout';

interface AppUserLogoutProps {
  user: any;
  labels: typeof strings.pt.start;
  menuLabels: typeof strings.pt.menu;
  globalStyles: any;
  setShowLanguageSelector: (value: boolean) => void;
  buDefaultFunctionalities: any;
}

const AppUserLogout = ({
  user,
  labels,
  menuLabels,
  globalStyles,
  setShowLanguageSelector,
  buDefaultFunctionalities,
}: AppUserLogoutProps) => {
  const history = useHistory();

  const {currentPath, handleSelect, handleNavigate} = useNavSelection(history);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [notificationCount, setNotificationCount] = useState(3);
  const isLanguageActive = useIsLanguageActive(buDefaultFunctionalities);
  const areNotificationsActive = useAreNotificationsActive(
    buDefaultFunctionalities
  );
  const [hoveredItem, setHoveredItem] = useState<boolean>(false);

  const allMenuLabels = {...strings.pt.menu, ...menuLabels};

  return (
    <AuthConsumer>
      {({logout}) => (
        <Row className="app-nav-menu-right">
          {isLanguageActive && (
            <div
              className="app-nav-menu-item"
              onClick={() => setShowLanguageSelector(true)}>
              <LanguageIcon sx={{color: globalStyles?.primaryColor}} />
              <div className="language-text-container">
                <span
                  style={{...fonts.M, color: colors.black}}
                  className="app-nav-menu-item__language">
                  {upperCase(user.language?.split('-')[0])}
                </span>
              </div>
            </div>
          )}
          {areNotificationsActive && (
            <div className="app-nav-menu-item" onClick={() => {}}>
              <EmailIcon sx={{color: globalStyles?.primaryColor}} />
              {notificationCount > 0 && (
                <span className="badge">{notificationCount}</span>
              )}
            </div>
          )}
          <div
            className="app-nav-menu-item user-menu"
            onMouseEnter={() => {
              setHoveredItem(true);
              setShowUserMenu(true);
            }}
            onMouseLeave={() => {
              setHoveredItem(false);
              setShowUserMenu(false);
            }}>
            <PersonIcon sx={{color: globalStyles?.primaryColor}} />
            <Icon
              color={globalStyles?.primaryColor}
              name={Icons.CHEVRON_DOWN}
              className={`app-nav-menu-arrow ${hoveredItem ? 'rotated' : ''}`}
            />
            {showUserMenu && (
              <div
                className="user-dropdown"
                style={{
                  ...fonts.S,
                  color: colors.black,
                }}>
                <div
                  className="app-nav-menu-sub-item"
                  onClick={() => history.push('/perfil')}>
                  <span
                    style={{
                      ...fonts.SemiBold,
                      ...fonts.M,
                      color: colors.black,
                    }}>
                    {allMenuLabels.menu_user__submenu_profile}
                  </span>
                </div>
                <div className="app-nav-menu-sub-item" onClick={logout}>
                  <LogoutIcon sx={{color: globalStyles?.primaryColor}} />
                  <span
                    className="pl-2"
                    style={{
                      ...fonts.SemiBold,
                      ...fonts.M,
                      color: colors.black,
                    }}>
                    {labels?.start_dropLogout}
                  </span>
                </div>
              </div>
            )}
          </div>
        </Row>
      )}
    </AuthConsumer>
  );
};

const mapStateToProps = ({
  user,
  strings,
  globalStyles,
  buDefaultFunctionalities,
}: any) => ({
  user: user.value,
  labels: strings.value.pt.start,
  menuLabels: strings.value.pt.menu,
  globalStyles: globalStyles.value,
  buDefaultFunctionalities: buDefaultFunctionalities.value,
});

export default compose(connect(mapStateToProps))(AppUserLogout);
